const IconComponent = ({ icon: Icon, ...props }) => {
  return <Icon {...props} />;
};

export default IconComponent;
